/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { PharmacyIndentType } from 'app/shared/model/enumerations/pharmacy-indent-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-stock-indent.reducer';

export const PharmacyStockIndentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyStockIndentEntity = useAppSelector(state => state.pharmacyStockIndent.entity);
  const loading = useAppSelector(state => state.pharmacyStockIndent.loading);
  const updating = useAppSelector(state => state.pharmacyStockIndent.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyStockIndent.updateSuccess);
  const pharmacyIndentStatusValues = Object.keys(PharmacyIndentStatus);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);
  const pharmacyIndentTypeValues = Object.keys(PharmacyIndentType);

  const handleClose = () => {
    navigate(`/pharmacy-stock-indent${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyStockIndentEntity,
      ...values,
      requestingPharmacy: pharmacies.find(it => it.id.toString() === values.requestingPharmacy?.toString()),
      fulfillingPharmacy: pharmacies.find(it => it.id.toString() === values.fulfillingPharmacy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          indentStatus: 'REQUESTED',
          pharmacyAddedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          fulfilledByType: 'PHARMACY',
          indentFor: 'REQUEST',
          ...pharmacyStockIndentEntity,
          requestingPharmacy: pharmacyStockIndentEntity?.requestingPharmacy?.id,
          fulfillingPharmacy: pharmacyStockIndentEntity?.fulfillingPharmacy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyStockIndent.home.createOrEditLabel" data-cy="PharmacyStockIndentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.home.createOrEditLabel">
              Create or edit a PharmacyStockIndent
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-stock-indent-id"
                  label={translate('tinyMedicRestApp.pharmacyStockIndent.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.indentStatus')}
                id="pharmacy-stock-indent-indentStatus"
                name="indentStatus"
                data-cy="indentStatus"
                type="select"
              >
                {pharmacyIndentStatusValues.map(pharmacyIndentStatus => (
                  <option value={pharmacyIndentStatus} key={pharmacyIndentStatus}>
                    {translate(`tinyMedicRestApp.PharmacyIndentStatus.${pharmacyIndentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.active')}
                id="pharmacy-stock-indent-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.cursor')}
                id="pharmacy-stock-indent-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.lastUpdated')}
                id="pharmacy-stock-indent-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.microSec')}
                id="pharmacy-stock-indent-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.timestampEntry')}
                id="pharmacy-stock-indent-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.addedById')}
                id="pharmacy-stock-indent-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.modifiedById')}
                id="pharmacy-stock-indent-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.fulfilledById')}
                id="pharmacy-stock-indent-fulfilledById"
                name="fulfilledById"
                data-cy="fulfilledById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.pharmacyAddedByType')}
                id="pharmacy-stock-indent-pharmacyAddedByType"
                name="pharmacyAddedByType"
                data-cy="pharmacyAddedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.modifiedByType')}
                id="pharmacy-stock-indent-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.fulfilledByType')}
                id="pharmacy-stock-indent-fulfilledByType"
                name="fulfilledByType"
                data-cy="fulfilledByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.indentFor')}
                id="pharmacy-stock-indent-indentFor"
                name="indentFor"
                data-cy="indentFor"
                type="select"
              >
                {pharmacyIndentTypeValues.map(pharmacyIndentType => (
                  <option value={pharmacyIndentType} key={pharmacyIndentType}>
                    {translate(`tinyMedicRestApp.PharmacyIndentType.${pharmacyIndentType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndent.indentNumber')}
                id="pharmacy-stock-indent-indentNumber"
                name="indentNumber"
                data-cy="indentNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                id="pharmacy-stock-indent-requestingPharmacy"
                name="requestingPharmacy"
                data-cy="requestingPharmacy"
                label={translate('tinyMedicRestApp.pharmacyStockIndent.requestingPharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-stock-indent-fulfillingPharmacy"
                name="fulfillingPharmacy"
                data-cy="fulfillingPharmacy"
                label={translate('tinyMedicRestApp.pharmacyStockIndent.fulfillingPharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-stock-indent" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyStockIndentUpdate;
